import * as React from "react";
import { forwardRef } from "react";
const SvgIcEqual = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.328125 1H10.4916", stroke: "#131F60", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M0.328125 6H10.4916", stroke: "#131F60", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgIcEqual);
export default ForwardRef;
